// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoclickController from "./autoclick_controller"
application.register("autoclick", AutoclickController)

import BodyController from "./body_controller"
application.register("body", BodyController)

import DashboardChartController from "./dashboard_chart_controller"
application.register("dashboard-chart", DashboardChartController)

import FilterBarController from "./filter_bar_controller"
application.register("filter-bar", FilterBarController)

import IntegerInputController from "./integer_input_controller"
application.register("integer-input", IntegerInputController)

import TableSqueezeController from "./table_squeeze_controller"
application.register("table-squeeze", TableSqueezeController)

import ClientSelectController from "./client_select_controller"
application.register("client-select", ClientSelectController)

import ContextModalController from "./context_modal_controller"
application.register("context-modal", ContextModalController)

import DatePickerController from "./date_picker_controller"
application.register("date-picker", DatePickerController)

import DownloadController from "./download_controller"
application.register("download", DownloadController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import FilterItemController from "./filter_item_controller"
application.register("filter-item", FilterItemController)

import FormController from "./form_controller"
application.register("form", FormController)

import FrameReloadController from "./frame_reload_controller"
application.register("frame-reload", FrameReloadController)

import FreetextSearchController from "./freetext_search_controller"
application.register("freetext-search", FreetextSearchController)

import LoginBackgroundController from "./login_background_controller"
application.register("login-background", LoginBackgroundController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ModalNotificationController from "./modal_notification_controller"
application.register("modal-notification", ModalNotificationController)

import RowController from "./row_controller"
application.register("row", RowController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SelectionController from "./selection_controller"
application.register("selection", SelectionController)

import SlimSelectController from "./slim_select_controller"
application.register("slim-select", SlimSelectController)

import TippyController from "./tippy_controller"
application.register("tippy", TippyController)

import TransferController from "./transfer_controller"
application.register("transfer", TransferController)

import TurboSelectController from "./turbo_select_controller"
application.register("turbo-select", TurboSelectController)

import FileListController from "./file_list_controller"
application.register("file-list", FileListController)

import UploadFileController from "./upload_file_controller"
application.register("upload-file", UploadFileController)

import ProgressController from "./progress_controller"
application.register("progress", ProgressController)

import ProgressBarController from "./progress_bar_controller"
application.register("progress-bar", ProgressBarController)

import PoolerSelectController from "./pooler_select_controller"
application.register("pooler-select", PoolerSelectController)

import ModalConfirmActionController from "./modal_confirm_action_controller"
application.register("modal-confirm-action", ModalConfirmActionController)

import ConfirmSubmitController from "./confirm_submit_controller"
application.register("confirm-submit", ConfirmSubmitController)

import StatePickerController from "./state_picker_controller"
application.register("state-picker", StatePickerController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)
